import { CircleInfo } from "@/icons/CircleInfo.tsx";
import { getProfile } from "@/services/profile.service.ts";
import useUserStore from "@/store/user.store.ts";
import { Alert, Notification, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";

export function SSO() {
  const { login } = useUserStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isTokenSet, setIsTokenSet] = useState(false);
  const token = searchParams.get("token");

  const { data } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
    enabled: !!token && isTokenSet,
  });

  useEffect(() => {
    if (token) {
      setIsTokenSet(true);
      localStorage.setItem("token", token);
    }
    if (data && token) {
      login(data.data, token);
      navigate("/dashboard");
    }
  }, [data, navigate, setIsTokenSet, token]);

  const icon = <CircleInfo />;

  return (
    <div className="mx-auto grid w-[350px] gap-6">
      {token && (
        <div className="grid gap-2 text-center">
          <Title order={1}>Signing in</Title>
        </div>
      )}

      {!token && (
        <Alert title="Something went wrong!" color="orange" icon={icon}>
          How did you get here?
        </Alert>
      )}

      {token && (
        <Notification withCloseButton={false} loading>
          Please wait while we sign you in!
        </Notification>
      )}
    </div>
  );
}
